import React from 'react';
import { Link } from 'react-router-dom';
import { FaEnvelope, FaPhone, FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { useMobileDetector } from '../utils/deviceDetection';

const Footer = () => {
  const isMobile = useMobileDetector();
  
  return (
    <footer className="bg-surface text-text pt-10 pb-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {isMobile ? (
          // Mobile Footer: Simplified layout
          <div className="space-y-8">
            {/* Logo & Contact */}
            <div className="text-center">
              <div className="text-2xl font-bold mb-4">AUTOLAWN</div>
              <div className="flex justify-center space-x-4 mb-2">
                <a href="mailto:support@autolawn.app" className="text-blue-400 hover:text-blue-300">
                  <FaEnvelope />
                </a>
                <a href="tel:+17249143764" className="text-blue-400 hover:text-blue-300">
                  <FaPhone />
                </a>
              </div>
              <div className="text-sm text-blue-100">support@autolawn.app</div>
              <div className="text-sm text-blue-100">(724) 914-3764</div>
            </div>
            
            {/* Quick Links */}
            <div className="grid grid-cols-2 gap-3 text-sm">
              <Link to="/features" className="text-blue-100 hover:text-blue-300">Features</Link>
              <Link to="/pricing" className="text-blue-100 hover:text-blue-300">Pricing</Link>
              <Link to="/faq" className="text-blue-100 hover:text-blue-300">FAQ</Link>
              <Link to="/training" className="text-blue-100 hover:text-blue-300">Training</Link>
              <Link to="/contact" className="text-blue-100 hover:text-blue-300">Contact</Link>
              <Link to="/about" className="text-blue-100 hover:text-blue-300">About Us</Link>
            </div>
          </div>
        ) : (
          // Desktop Footer: Full layout
          <div>
            <div className="grid md:grid-cols-4 gap-8 mb-8">
              {/* Company Info */}
              <div>
                <div className="text-2xl font-bold mb-4">AUTOLAWN</div>
                <p className="text-blue-100 mb-4">
                  Empowering lawn care professionals with modern software solutions.
                </p>
                <div className="flex space-x-4">
                  <a href="https://facebook.com" className="text-blue-400 hover:text-blue-300">
                    <FaFacebook />
                  </a>
                  <a href="https://twitter.com" className="text-blue-400 hover:text-blue-300">
                    <FaTwitter />
                  </a>
                  <a href="https://instagram.com" className="text-blue-400 hover:text-blue-300">
                    <FaInstagram />
                  </a>
                  <a href="https://linkedin.com" className="text-blue-400 hover:text-blue-300">
                    <FaLinkedin />
                  </a>
                </div>
              </div>
              
              {/* Quick Links */}
              <div>
                <h3 className="text-lg font-semibold mb-3 text-white">Quick Links</h3>
                <ul className="space-y-2">
                  <li><Link to="/features" className="text-blue-100 hover:text-blue-300">Features</Link></li>
                  <li><Link to="/pricing" className="text-blue-100 hover:text-blue-300">Pricing</Link></li>
                  <li><Link to="/faq" className="text-blue-100 hover:text-blue-300">FAQ</Link></li>
                  <li><Link to="/training" className="text-blue-100 hover:text-blue-300">Training</Link></li>
                </ul>
              </div>
              
              {/* Company */}
              <div>
                <h3 className="text-lg font-semibold mb-3 text-white">Company</h3>
                <ul className="space-y-2">
                  <li><Link to="/about" className="text-blue-100 hover:text-blue-300">About Us</Link></li>
                  <li><Link to="/contact" className="text-blue-100 hover:text-blue-300">Contact</Link></li>
                  <li><a href="#" className="text-blue-100 hover:text-blue-300">Careers</a></li>
                  <li><a href="#" className="text-blue-100 hover:text-blue-300">Privacy Policy</a></li>
                </ul>
              </div>
              
              {/* Contact */}
              <div>
                <h3 className="text-lg font-semibold mb-3 text-white">Contact Us</h3>
                <ul className="space-y-2">
                  <li className="flex items-center text-blue-100">
                    <FaEnvelope className="mr-2 text-blue-400" />
                    <a href="mailto:support@autolawn.app" className="hover:text-blue-300">support@autolawn.app</a>
                  </li>
                  <li className="flex items-center text-blue-100">
                    <FaPhone className="mr-2 text-blue-400" />
                    <a href="tel:+17249143764" className="hover:text-blue-300">(724) 914-3764</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )}
        
        {/* Copyright - Both versions */}
        <div className={`${isMobile ? 'mt-8' : 'mt-10'} pt-6 border-t border-gray-700 text-center`}>
          <p className="text-blue-100 text-sm">
            &copy; {new Date().getFullYear()} AUTOLAWN. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 